/**
 * @generated SignedSource<<3627c786741dd66f29f4b9d69e7037c4>>
 * @relayHash e16f1f37094290856f2a176fae2b4a82
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ca763d1cc10124c4880d846781f37b4b05f855bea0105e995e7d4fbbc8da768

import type { ConcreteRequest } from 'relay-runtime';
export type JiraRovoAiProduct = "JIRA" | "JIRA_CUSTOMER_SERVICE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_MANAGEMENT" | "%future added value";
export type ServicesAndSkillsSetupActionPreloadedQuery$variables = {
  cloudId: string;
  isJsmRoutingFixesForGaEnabled: boolean;
  projectKey: string;
};
export type ServicesAndSkillsSetupActionPreloadedQuery$data = {
  readonly agentWorkspace_routingConfig: {
    readonly enabled: boolean;
  } | null;
  readonly jira_rovoEnablementStatus?: {
    readonly isRovoEntitlementEnabledForTenant: boolean | null;
    readonly rovoAiFeaturesEnabledJiraProducts: ReadonlyArray<JiraRovoAiProduct> | null;
  } | null;
};
export type ServicesAndSkillsSetupActionPreloadedQuery = {
  response: ServicesAndSkillsSetupActionPreloadedQuery$data;
  variables: ServicesAndSkillsSetupActionPreloadedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJsmRoutingFixesForGaEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = [
  {
    "condition": "isJsmRoutingFixesForGaEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "concreteType": "JiraRovoEnablementStatus",
        "kind": "LinkedField",
        "name": "jira_rovoEnablementStatus",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isRovoEntitlementEnabledForTenant"
          },
          {
            "kind": "ScalarField",
            "name": "rovoAiFeaturesEnabledJiraProducts"
          }
        ]
      }
    ]
  },
  {
    "args": [
      (v3/*: any*/),
      {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
      }
    ],
    "concreteType": "AgentWorkspaceSmartRoutingConfig",
    "kind": "LinkedField",
    "name": "agentWorkspace_routingConfig",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "enabled"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ServicesAndSkillsSetupActionPreloadedQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ServicesAndSkillsSetupActionPreloadedQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "id": "1ca763d1cc10124c4880d846781f37b4b05f855bea0105e995e7d4fbbc8da768",
    "metadata": {},
    "name": "ServicesAndSkillsSetupActionPreloadedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f26160eed026734b7af63077cd5d0ac2";

export default node;
